import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FocusDiv } from '#/widgets/ui';
import { ROLES } from '#/utils/accessibility';
import MenuIconFocused from '#/static/images/icons/menu-icon-focused.svg';
import styles from './tvMenuIcon.scss';

const TVMenuIcon = ({
  src,
  nav,
  name,
  onClick,
  selected = false,
  ariaLabel,
}) => {
  const [icon, setIcon] = useState(null);
  const [isFocused, toggleFocused] = useState(false);

  const fileName = !selected
    ? `menu-${name?.replace(' ', '').toLowerCase()}.svg`
    : `menu-${name?.replace(' ', '').toLowerCase()}-selected.svg`;

  const onFocus = useCallback(() => toggleFocused(true), []);
  const onBlur = useCallback(() => toggleFocused(false), []);

  useEffect(() => {
    if (src) {
      setIcon(src);
    } else {
      import(`#/static/images/icons/${fileName}`)
        .then(iconModule => {
          setIcon(iconModule);
        })
        .catch(() => {
          console.error(`Cannot find icon module: ${name} `);
        });
    }
  }, [name, selected]);

  const render = () => {
    if (!icon) {
      return null;
    }
    return (
      <FocusDiv
        nav={nav}
        ariaLabel={ariaLabel}
        onFocus={onFocus}
        onBlur={onBlur}
        style={{ outline: 'none' }}
        role={ROLES.NAVIGATION}
        className={styles.buttonContainer}
        onClick={onClick}
      >
        <button
          className={classNames(styles.button, {
            [styles.buttonFocused]: isFocused,
          })}
        >
          <div
            className={selected ? styles.selectedOverlay : null}
            aria-hidden="true"
          />
          <img
            className={classNames(styles.menuIcon, { [styles.circular]: src })}
            src={src || icon.default}
            alt={name}
          />
          <img
            className={classNames(styles.menuIconFocused, {
              [styles.isFocused]: isFocused,
            })}
            src={MenuIconFocused}
            alt={`${name}Focused`}
          />
          <div
            className={classNames(styles.menuIconLabel, {
              [styles.isFocused]: isFocused,
            })}
          >
            {name}
          </div>
        </button>
      </FocusDiv>
    );
  };

  return <>{render()}</>;
};

TVMenuIcon.propTypes = {
  src: PropTypes.string,
  nav: PropTypes.object,
  name: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default TVMenuIcon;
